export default __webpack_public_path__ + "static/media/illus14.92b67582.png";